module.exports = {
  chargePartTypeKG: 'Разделение по весу (кг)',
  chargePartTypeCBM: 'Тарификация по объёму (м³)',
  chargePartTypeTipsL1: 'Подсказка: что такое тип тарифного диапазона?',
  chargePartTypeTipsL2: 'Разделение по весу (кг) означает, что стоимость перевозки зависит от веса груза.',
  chargePartTypeTipsL3: 'Разделение по объёму (м³) означает, что стоимость перевозки зависит от объёма груза.'
}
